import { render, staticRenderFns } from "./GraficoLegenda.vue?vue&type=template&id=0b215608"
import script from "./GraficoLegenda.vue?vue&type=script&lang=ts"
export * from "./GraficoLegenda.vue?vue&type=script&lang=ts"
import style0 from "./GraficoLegenda.vue?vue&type=style&index=0&id=0b215608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports